import { render, staticRenderFns } from "./ManageTopic.vue?vue&type=template&id=467ce377&scoped=true&"
import script from "./ManageTopic.vue?vue&type=script&lang=js&"
export * from "./ManageTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467ce377",
  null
  
)

export default component.exports